export default [
  {
    path: "/settings/oauth-clients",
    name: "OAuthClients",
    component: () => import("@/views/oauth-integrations/index.vue"),
    meta: {
      label: "OAuth Clients",
      permission: "show_oauth_clients",
    },
  },
  {
    path: "/settings/oauth-clients/create",
    name: "CreateOAuthClient",
    component: () => import("@/views/oauth-integrations/create.vue"),
    meta: {
      label: "Create OAuth Client",
      permission: "create_oauth_clients",
    },
  },
  {
    path: "/settings/oauth-clients/:id",
    name: "ShowOAuthClient",
    component: () => import("@/views/oauth-integrations/show.vue"),
    meta: {
      label: "OAuth Client Details",
      permission: "show_oauth_clients",
    },
  },
  {
    path: "/settings/oauth-clients/:id/edit",
    name: "EditOAuthClient",
    component: () => import("@/views/oauth-integrations/create.vue"),
    meta: {
      label: "Edit OAuth Client",
      permission: "edit_oauth_clients",
    },
  },
];
